var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Utils } from '../../utils';
import { PropertyConverters } from '../../converters';
import { PacemItemsContainerElement } from '../basic';
import { Watch, CustomElement } from '../../decorators';
import { P } from '../../prefix';
import { AnimationElement } from './animation';
//namespace Pacem.Components {
let PacemStoryboardElement = class PacemStoryboardElement extends PacemItemsContainerElement {
    validate(item) {
        return item instanceof AnimationElement;
    }
    viewActivatedCallback() {
        super.viewActivatedCallback();
        this._animate();
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        if (!first) {
            switch (name) {
                case 'datasource':
                    this._buildDatasourceFromDatasource(val);
                    break;
                case 'items':
                    this._buildDatasourceFromItems(val);
                    break;
                case '_adaptedDatasource':
                case 'autostart':
                    this._animate();
                    break;
            }
        }
    }
    _buildDatasourceFromItems(items = this.items) {
        this._adaptedDatasource = items || [];
    }
    _buildDatasourceFromDatasource(ds = this.datasource) {
        this._adaptedDatasource = ds || [];
    }
    _animate(start = this.autostart) {
        const ds = this._adaptedDatasource;
        const promises = [];
        if (start && !Utils.isNullOrEmpty(ds)) {
            for (let timeline of ds) {
                promises.push(timeline.startAnimation());
            }
        }
        return Promise.all(promises);
    }
    cancelAnimation() {
        const ds = this._adaptedDatasource || [];
        for (let timeline of ds) {
            timeline.cancelAnimation();
        }
    }
    startAnimation() {
        return this._animate(true);
    }
};
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Boolean })
], PacemStoryboardElement.prototype, "autostart", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], PacemStoryboardElement.prototype, "duration", void 0);
__decorate([
    Watch({ emit: false })
], PacemStoryboardElement.prototype, "datasource", void 0);
__decorate([
    Watch({ emit: false })
], PacemStoryboardElement.prototype, "_adaptedDatasource", void 0);
PacemStoryboardElement = __decorate([
    CustomElement({ tagName: P + '-storyboard' })
], PacemStoryboardElement);
export { PacemStoryboardElement };
